import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../TextField/TextFeild";
import SelectBox from "../CountryDropDown/SelectBox";
import { addTeamMember, getInvitesList, sendNewInvite } from "../../store/slices/invitesSlice";
import { toast } from "react-toastify";
import { STATION_GROUPS, STATION_GROUPS_1 } from "../../constants";

const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    school: Yup.string().required("Organization is required"),
    email: Yup.string().email("Invalid email address"),
    stationGroup: Yup.string().required("station Group is Required."),
});

const StationInvite = ({ show, onClose }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (show) {
            formik.resetForm();
        }
    }, [show]);


    const formik = useFormik({
        initialValues: {
            school: '',
            firstName: '',
            lastName: '',
            email: '',
            stationGroup: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const payload = {
                type: 'invite',
                attributes: {
                    email: values.email,
                    stationGroup: values.stationGroup,
                    ctx: {
                        svg: STATION_GROUPS[values.stationGroup] == STATION_GROUPS.radiomax ? 1 : 0,
                        school: values.school,
                        firstName: values.firstName,
                        lastName: values.lastName,
                    }
                }
            }
            dispatch(
                sendNewInvite({
                    message: 'Invite sent successfully.',
                    payload
                })
            ).unwrap().then(() => {
                dispatch(getInvitesList());
                onClose();
                resetForm();
            }).catch((errMsg) => {
                toast.error(errMsg, {
                    position: "top-right",
                });
            });
        },
    });

    const stationGroupOptions = Object.entries(STATION_GROUPS_1).map(([key, label]) => ({
        label,
        value: key,
    }));

    return (
        <Modal show={show} size="lg" onHide={onClose} centered backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Send an Invitation</Modal.Title>
            </Modal.Header>
            <form className="" onSubmit={formik.handleSubmit}>
                <div className="form-card shadow-none">
                    <div className="">
                        <CustomInput
                            label="First Name"
                            id="firstName"
                            name="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.firstName && formik.errors.firstName}
                            required
                        />

                        <CustomInput
                            label="Last Name"
                            id="lastName"
                            name="lastName"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.lastName && formik.errors.lastName}
                            required
                        />

                        <CustomInput
                            label="Email"
                            id="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && formik.errors.email}
                            required
                        />
                        <CustomInput
                            label="Organization"
                            id="school"
                            name="school"
                            value={formik.values.school}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.school && formik.errors.school}
                            required
                        />

                        <SelectBox
                            name="stationGroup"
                            selectedValue={formik.values.stationGroup}
                            onChangeFn={(value) => {
                                formik.setFieldValue("stationGroup", value);
                            }}
                            label="Group"
                            options={stationGroupOptions}
                            onBlur={formik.handleBlur}
                            value={formik.values.stationGroup}
                            error={formik.touched.stationGroup && formik.errors.stationGroup}
                            isSearchable={false}
                            multiple={false}
                        />



                    </div>
                </div>
                <div className="text-right p-3">
                    <div className="button-div ">
                        <button
                            type="button"
                            className="btn btn-outline-danger mx-3"
                            disabled={formik.isSubmitting}
                            onClick={onClose}
                        >
                            <span>Cancel</span>
                        </button>
                        <button type="submit" className="btn btn-secondary" disabled={formik.isSubmitting}>
                            <span>{formik.isSubmitting ? "Creating..." : "Create"}</span>
                        </button>

                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default StationInvite;
